import React from "react";
import Tickets from "./Tickets";

const CustomerTickets = () => {
  return <Tickets />;
};

export default CustomerTickets;
